function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { NetworkSampleType, SmootherType } from '@sky-uk-ott/vpt-abr-network-estimator';
import { TrackType } from '@sky-uk-ott/vpt-abr';
import { getShakaRestrictionsChecker } from './shaka-abr-restrictions';
import { AbrToShakaWrapper } from './abr-to-shaka-wrapper';
import { sdkLogger } from '../../../logger';
import { ShakaPlayerEventType } from '../shaka.enums';
import { isVersionCompliant, MINIMUM_VERSION_FOR_UPSTREAM_PATCH } from '../shaka-version-utils';
var DEFAULT_SEGMENT_DURATION = 0;
var DEFAULT_SWITCH_INTERVAL_SEGMENTS = 0;
export var ShakaToAbrWrapper = /*#__PURE__*/ function() {
    "use strict";
    function ShakaToAbrWrapper(abrManager, player, onDestroy, shakaSpecificConfig) {
        _class_call_check(this, ShakaToAbrWrapper);
        _define_property(this, "abrManager", void 0);
        _define_property(this, "player", void 0);
        _define_property(this, "onDestroy", void 0);
        _define_property(this, "switchVariant", void 0);
        _define_property(this, "lastTimeChosenMs", void 0);
        _define_property(this, "numberOfRequestSeenSinceLastSwitch", void 0);
        _define_property(this, "variants", void 0);
        _define_property(this, "validVariants", void 0);
        _define_property(this, "isEnabled", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "shakaAbrConfig", void 0);
        _define_property(this, "hasSetupWithMediaElement", void 0);
        _define_property(this, "shakaSpecificConfig", void 0);
        _define_property(this, "bandwidthEstimator", void 0);
        _define_property(this, "bandwidthSmoother", void 0);
        this.abrManager = abrManager;
        this.player = player;
        this.onDestroy = onDestroy;
        this.lastTimeChosenMs = 0;
        this.numberOfRequestSeenSinceLastSwitch = 0;
        this.variants = [];
        this.validVariants = [];
        this.isEnabled = false;
        this.hasSetupWithMediaElement = false;
        this.bandwidthEstimator = this.abrManager.getBandwidthEstimator();
        this.logger = sdkLogger.withContext('ShakaToAbr');
        var defaultConfig = {
            removeLatencyFromFirstPacketTime: false,
            segmentDurationSeconds: DEFAULT_SEGMENT_DURATION,
            smootherConfig: {
                type: SmootherType.LAST_SAMPLE
            },
            switchIntervalSegments: DEFAULT_SWITCH_INTERVAL_SEGMENTS
        };
        this.shakaSpecificConfig = _object_spread({}, defaultConfig, shakaSpecificConfig);
        this.bandwidthSmoother = this.bandwidthEstimator.getSmoother(this.shakaSpecificConfig.smootherConfig);
        // this should come from the player eventually but can come from config for now.
        this.abrManager.submitSegmentDurationSeconds(this.shakaSpecificConfig.segmentDurationSeconds);
    }
    _create_class(ShakaToAbrWrapper, [
        {
            key: "chooseVariant",
            value: function chooseVariant() {
                var combinedTrack = this.abrManager.getRecommendedTracks();
                if (!combinedTrack) {
                    return null;
                }
                var shakaVariantSelected = this.validVariants.find(function(variant) {
                    var _variant_audio, _variant_video;
                    return ((_variant_audio = variant.audio) === null || _variant_audio === void 0 ? void 0 : _variant_audio.id.toString()) === combinedTrack.audioTrack.id && ((_variant_video = variant.video) === null || _variant_video === void 0 ? void 0 : _variant_video.id.toString()) === combinedTrack.videoTrack.id;
                });
                if (!shakaVariantSelected) {
                    this.logger.error("Tried to select a variant that didn't exist in Shaka's model");
                    return null;
                }
                this.logger.info('Chose Variant: ', shakaVariantSelected.bandwidth);
                return shakaVariantSelected;
            }
        },
        {
            key: "setVariants",
            value: function setVariants(variants) {
                var _this_shakaAbrConfig;
                this.logger.info('Variants received', variants);
                this.variants = variants;
                this.setValidTracksRestrictions((_this_shakaAbrConfig = this.shakaAbrConfig) === null || _this_shakaAbrConfig === void 0 ? void 0 : _this_shakaAbrConfig.restrictions);
            }
        },
        {
            key: "setValidTracksRestrictions",
            value: function setValidTracksRestrictions(restrictions) {
                this.validVariants = this.getValidVariants(this.variants, restrictions);
                var combinedTracks = this.getNormalisedTracks();
                this.abrManager.setAvailableTracks(combinedTracks);
            }
        },
        {
            key: "getNormalisedTracks",
            value: function getNormalisedTracks() {
                var combinedTracks = this.validVariants.reduce(function(acc, shakaVariant) {
                    if (!shakaVariant.audio || !shakaVariant.audio.bandwidth || !shakaVariant.video || !shakaVariant.video.bandwidth) {
                        return acc;
                    }
                    return _to_consumable_array(acc).concat([
                        {
                            combinedBandwidth: shakaVariant.audio.bandwidth + shakaVariant.video.bandwidth,
                            audioTrack: {
                                type: TrackType.Audio,
                                id: shakaVariant.audio.id.toString(),
                                bandwidth: shakaVariant.audio.bandwidth
                            },
                            videoTrack: {
                                type: TrackType.Video,
                                id: shakaVariant.video.id.toString(),
                                bandwidth: shakaVariant.video.bandwidth
                            }
                        }
                    ]);
                }, []);
                return combinedTracks;
            }
        },
        {
            key: "init",
            value: function init(switchCb) {
                this.switchVariant = switchCb;
            }
        },
        {
            key: "configure",
            value: function configure(config) {
                this.logger.info('Config received:', config);
                this.shakaAbrConfig = config;
                if (this.variants.length) {
                    this.setValidTracksRestrictions(config.restrictions);
                }
                this.setupWithMediaElement();
            }
        },
        {
            key: "setMediaElement",
            value: function setMediaElement(mediaElement) {
                if (mediaElement) {
                    this.setupWithMediaElement();
                }
            }
        },
        {
            key: "setupWithMediaElement",
            value: function setupWithMediaElement() {
                var _config_advanced;
                if (this.hasSetupWithMediaElement) {
                    return;
                }
                var mediaElement = this.player.getMediaElement();
                if (!mediaElement) {
                    return;
                }
                this.hasSetupWithMediaElement = true;
                var config = this.shakaAbrConfig || {};
                var abrToPlayer = new AbrToShakaWrapper(this.player);
                this.abrManager.registerAbrToPlayer(abrToPlayer);
                this.abrManager.setBandwidthEstimationConfig({
                    defaultBandwidthEstimate: config.defaultBandwidthEstimate,
                    minTotalBytes: (_config_advanced = config.advanced) === null || _config_advanced === void 0 ? void 0 : _config_advanced.minTotalBytes
                });
                if (isVersionCompliant(shaka.Player.version, MINIMUM_VERSION_FOR_UPSTREAM_PATCH)) {
                    // v4
                    this.player.addEventListener(ShakaPlayerEventType.segmentdownloaded, this.downloadComplete.bind(this));
                } else {
                    this.player.addEventListener(ShakaPlayerEventType.segmentDownloaded, this.downloadComplete.bind(this));
                }
            }
        },
        {
            key: "checkIsValidDownloadEventDetail",
            value: // to be removed when shaka v3 is phased out.
            function checkIsValidDownloadEventDetail(detail) {
                var _detail_response, _detail_request, _detail_response1;
                if (!('response' in detail) && !('response' in detail)) {
                    return false;
                }
                return Number.isFinite((_detail_response = detail.response) === null || _detail_response === void 0 ? void 0 : _detail_response.timeMs) && Number.isFinite((_detail_request = detail.request) === null || _detail_request === void 0 ? void 0 : _detail_request.timeToFirstByte) && Number.isFinite((_detail_response1 = detail.response) === null || _detail_response1 === void 0 ? void 0 : _detail_response1.data.byteLength);
            }
        },
        {
            key: "getNetworkSampleTypeFromContentType",
            value: function getNetworkSampleTypeFromContentType(contentType) {
                if (contentType.includes('video')) {
                    return NetworkSampleType.Video;
                }
                if (contentType.includes('audio')) {
                    return NetworkSampleType.Audio;
                }
                return undefined;
            }
        },
        {
            key: "downloadComplete",
            value: function downloadComplete(event) {
                this.numberOfRequestSeenSinceLastSwitch++;
                var detail = event.detail;
                var requestSample;
                if (this.checkIsValidDownloadEventDetail(detail)) {
                    requestSample = {
                        downloadTimeMs: detail.response.timeMs,
                        latencyMs: detail.request.timeToFirstByte,
                        bytesDownloaded: detail.response.data.byteLength,
                        sampleType: this.getNetworkSampleTypeFromContentType(detail.request.contentType),
                        timeRecorded: Date.now()
                    };
                    this.abrManager.submitRequestSample(requestSample);
                }
            }
        },
        {
            key: "segmentDownloaded",
            value: function segmentDownloaded(timeToDownloadMs, numBytes, _allowSwitch, request) {
                var _this_shakaAbrConfig;
                /**
         * Below is shaka specific logic so lives here.
         * -1 is emitted when a timeout occurs
         * see https://github.com/sky-uk/shaka-player/blob/2b8746898a3ede127a0aa025114ead71c7194abf/lib/net/networking_engine.js#L499-L512
         */ if (numBytes === -1) {
                    this.bandwidthEstimator.forceUpdate();
                    this.bandwidthSmoother.getValue();
                    return;
                }
                var downloadTime = timeToDownloadMs;
                if (this.shakaSpecificConfig.removeLatencyFromFirstPacketTime) {
                    downloadTime = (request === null || request === void 0 ? void 0 : request.packetNumber) === 1 ? timeToDownloadMs - request.timeToFirstByte : timeToDownloadMs;
                }
                var bandwidthSample = {
                    timeToDownloadMs: downloadTime,
                    numBytes: numBytes,
                    timeRecorded: Date.now()
                };
                this.abrManager.submitBandwidthSample(bandwidthSample);
                var now = Date.now();
                var delta = now - this.lastTimeChosenMs;
                if (((_this_shakaAbrConfig = this.shakaAbrConfig) === null || _this_shakaAbrConfig === void 0 ? void 0 : _this_shakaAbrConfig.switchInterval) && delta < this.shakaAbrConfig.switchInterval * 1000) {
                    return;
                }
                if (this.shakaSpecificConfig.switchIntervalSegments && this.numberOfRequestSeenSinceLastSwitch <= this.shakaSpecificConfig.switchIntervalSegments) {
                    return;
                }
                this.changeVariant();
            }
        },
        {
            key: "getBandwidthEstimate",
            value: function getBandwidthEstimate() {
                return this.bandwidthSmoother.getValue();
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.isEnabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.isEnabled = false;
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.isEnabled = false;
                this.variants = [];
                this.validVariants = [];
                this.switchVariant = undefined;
                this.abrManager.destroy();
            }
        },
        {
            key: "release",
            value: function release() {
                this.abrManager.destroy();
                if (isVersionCompliant(shaka.Player.version, MINIMUM_VERSION_FOR_UPSTREAM_PATCH)) {
                    // v4
                    this.player.removeEventListener(ShakaPlayerEventType.segmentdownloaded, this.downloadComplete);
                } else {
                    this.player.removeEventListener(ShakaPlayerEventType.segmentDownloaded, this.downloadComplete);
                }
                // to be removed when shaka v3 is phased out.
                this.onDestroy();
            }
        },
        {
            key: "playbackRateChanged",
            value: function playbackRateChanged(rate) {
                this.abrManager.notifiedPlaybackRateChange(rate);
            }
        },
        {
            key: "getValidVariants",
            value: function getValidVariants(variants, restrictions) {
                if (!restrictions) {
                    return variants;
                }
                var checkVariantMatchesRestrictions = getShakaRestrictionsChecker(restrictions);
                var validVariants = variants.filter(checkVariantMatchesRestrictions);
                return validVariants.length ? validVariants : [
                    variants[0]
                ];
            }
        },
        {
            key: "changeVariant",
            value: function changeVariant() {
                if (this.isEnabled) {
                    var chosenVariant = this.chooseVariant();
                    if (chosenVariant) {
                        var _this_switchVariant, _this;
                        (_this_switchVariant = (_this = this).switchVariant) === null || _this_switchVariant === void 0 ? void 0 : _this_switchVariant.call(_this, chosenVariant);
                        this.lastTimeChosenMs = Date.now();
                        this.numberOfRequestSeenSinceLastSwitch = 0;
                    }
                }
            }
        }
    ]);
    return ShakaToAbrWrapper;
}();

//# sourceMappingURL=shaka-to-abr-wrapper.js.map